import { useQuery } from "@tanstack/react-query";
import adminApiClient from "../../../../api/admin";

export type ClockInfo = {
  id: string;
  idf: string;
  currentIdf: string;
  heartbeat: string;
  location?: {
    latitude: number;
    longitude: number;
    country_code: string;
    city: string;
  };
  version?: number;
};

const useClockDetailsByIds = (clockIds: string[]) => {
  const sortedClockIds = clockIds.slice().sort();

  return useQuery({
    queryKey: ["clockDetailsByIds", ...sortedClockIds],
    queryFn: async () => {
      if (!clockIds || clockIds.length === 0) return [];

      const clockDetails = await Promise.all(
        clockIds.map(async (clockId) => {
          try {
            const clock = await adminApiClient.getClock(clockId);
            return {
              id: clock.id,
              idf: clock.idf,
              currentIdf: clock.currentIdf,
              heartbeat: clock.heartbeat,
              location: clock.location,
              version: clock.version,
            };
          } catch (error) {
            console.error(`Failed to fetch clock ${clockId}:`, error);
            return null;
          }
        }),
      );

      return clockDetails.filter(Boolean) as ClockInfo[];
    },

    placeholderData: (previousData) => {
      // Only show previous data that matches current clockIds
      if (!previousData) return undefined;

      const currentClockIdSet = new Set(sortedClockIds);
      const filteredData = previousData.filter((clock) =>
        currentClockIdSet.has(clock.id),
      );

      return filteredData.length > 0 ? filteredData : undefined;
    },
    enabled: clockIds && clockIds.length > 0,
  });
};

export default useClockDetailsByIds;
